import { MapContainer, TileLayer, Marker, Popup, useMap } from 'react-leaflet'
import { useNavigate } from 'react-router-dom';
import L from 'leaflet'

export default function GeoMap(props) {
  const cityes = props.cityes;
  const center = cityes.length > 0 ? [cityes[0].coord.lat, cityes[0].coord.lon] : []

  const latlngs = cityes.map(c => {
    return [c.coord.lat, c.coord.lon]
  })

  return (
    <>
      <MapContainer 
        zoom={13}
        style={{height:'100%', width:'100%', borderRadius:'10px'}}
        doubleClickZoom={true}
        scrollWheelZoom={true}
        >

          <MapController latlngs={latlngs}/>
          <AddMarkers cityes={cityes} activeLink={props.activeLink}/>

        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        

      </MapContainer>
    </>
  )
}

function MapController(props) {
  const map = useMap()

  if (props.latlngs.length > 0) {
    var bounds = new L.LatLngBounds(props.latlngs);
    map.fitBounds(bounds);
  }
  else {
    map.setView([0, 0], 0);
  }
  
  return null
}

function AddMarkers(props){
  const map = useMap()
  const navigate = useNavigate()
  const cityes = props.cityes
  const activeLink = props.activeLink

  for(let city of cityes){
    var marker = L.marker([city.coord.lat, city.coord.lon]).addTo(map);
    if(activeLink){
      marker.on('click', ()=>{
        navigate('/city/' + city.id)
      })
    }
  }
  return null
}